import styled, {css} from 'styled-components'

export const StyledDropdownRoot = styled.div`
    ${() => css`
        position: relative;
        & svg {
            cursor: pointer;
        }
    `}
`

export const StyledMenuWrapper = styled.div`
    ${({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: ${spacing * 3}px;
        padding: ${spacing * 3}px 0px;
    `}
`

export const StyledMenuItem = styled.div`
    ${({theme: {palette, typography, spacing}}) => css`
        ${typography.textS}
        display: grid;
        grid-template-columns: 1fr auto;
        gap: ${spacing * 2}px;
        cursor: pointer;
        color: ${palette.gray.main};
        font-weight: 500;
        transition: color 0.3s ease;
        padding: 0px ${spacing * 3}px;
        align-items: center;
        text-wrap: nowrap;
        white-space: nowrap;
        &:hover {
            color: ${palette.blue.main};
        }
        & div {
            width: 18px;
            display: flex;
            justify-content: center;
        }
    `}
`

export const StyledDivider = styled.div`
    ${({theme: {palette}}) => css`
        border-top: 1px solid ${palette.gray.disabled};
        width: 100%;
    `}
`
